import React, { useEffect, useState } from "react";
import { ReMixChart } from "../../components/recharts/ReMixCharts";
import { BrushStart, ChartType } from "../../models/chart_model";
import { COLOR_CODES, formatDMY } from "../../common";
import { FilterTab } from "../../components/Filters";
import { ChartTable } from "../../components/table/SummaryTable";
// import { getCollectiveData } from '../../Rest_api/restapi';
import {
  ChartData,
  ChartDataParams,
  FormatChartData,
} from "../../components/recharts/functions";
// import { FilterExchangeData } from '../home/fill_missing';
import { TopBuyerSellerTable } from "./TopBuyerSellerTable";
import { FilterExchangeData } from "../../store/state/Exchange/function";
import { buildHttpResponse, HttpMethod } from "../../Rest_api/Network_utility";
import { fetchExchangeSlotData } from "../../Rest_api/RestApi";
import Popup from "../Dashboard/Exchange3/components/Popup";
import { BuyerSellerChart } from "../Dashboard/Exchange3/Chart";
import { ExchangeBidData } from "../../models/exchangeBidData";

const views = ["Chart", "Table"];
const tabs = ["Volume", "Participant"];

export function MarketBiddingVolumeChart({
  startDate,
  endDate,
  isFullscreen = false,
}: {
  startDate: string;
  endDate: string;
  isFullscreen?: boolean;
}) {
  const [collectiveData, setCollectiveData] = useState<ExchangeBidData[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedView, setSelectedView] = useState(views[0]);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [lastVolumeView, setLastVolumeView] = useState(views[0]); // Store last selected view for Volume tab
  const [chartData, setChartData] = useState<ChartData>({
    keys: [],
    unit_keys: [],
    keysLabels: [],
    group_by: {},
    data: [],
  });
  const [popUpVisible, setPopUpVisible] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [popupData, setPopupData] = useState<{
    buyer: any[];
    seller: any[];
  }>({
    buyer: [],
    seller: [],
  });

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      async function getCollectiveData(
        startDate: string,
        endDate: string,
      ): Promise<ExchangeBidData[]> {
        const response = await buildHttpResponse({
          endPoint: `https://api-data.gna.energy/data/getData/?start_date=${startDate}&end_date=${endDate}`,
          customHeader: {
            "Content-Type": "application/json",
            Authorization: `259ba455-e622-45c6-8450-24bd5c574965`,
          },
          method: HttpMethod.GET,
        });
        return response.data.map((item: any) => ({
          ...item,
          wt_mcp_rs_mwh: parseFloat(item.wt_mcp_rs_mwh),
          purchase_bid_mwh: parseFloat(item.purchase_bid_mw) / 4,
          sell_bid_mwh: parseFloat(item.sell_bid_mw) / 4,
          mcv_mwh: parseFloat(item.mcv_mw) / 4,
        }));
      }
      const data = await getCollectiveData(startDate, endDate);
      // Filter for IEX DAM data (exchangeIndex: 0, exchangeProductIndex: 0)
      const filteredData = FilterExchangeData(data, {
        exchangeIndex: 0,
        exchangeProductIndex: 0,
      }).map((item) => ({
        ...item,
        date: formatDMY(item.date),

        purchase_bid_mwh: item.purchase_bid_mw / 4,
        sell_bid_mwh: item.sell_bid_mw / 4,
        mcv_mwh: item.mcv_mw / 4,
      }));
      setCollectiveData(filteredData as ExchangeBidData[]);
    } catch (error) {
      console.error("Error fetching collective data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTab === "Volume") {
      processVolumeData();
    }
  }, [collectiveData, selectedTab]);
  console.log("collectiveData", collectiveData);
  console.log("chartData.data", chartData.data);

  // Handler for chart bar click events - fetches detailed slot data
  const handleBarClick = async (data: any) => {
    try {
      setIsLoading(true);
      console.log("Bar clicked - full data structure:", data);
      console.log("data.payload:", data.payload);
      console.log("data.data:", data.data);
      console.log("data.dataIndex:", data.dataIndex);

      // Extract date from the clicked data - try different possible locations
      let clickedDate = null;

      // Try different possible locations for the date
      if (data.payload?.date) {
        clickedDate = data.payload.date;
      } else if (data.data?.date) {
        clickedDate = data.data.date;
      } else if (
        data.dataIndex !== undefined &&
        chartData.data[data.dataIndex]
      ) {
        clickedDate = chartData.data[data.dataIndex].date;
      } else if (
        data.dataIndex !== undefined &&
        collectiveData[data.dataIndex]
      ) {
        // Fallback to original collective data
        clickedDate = collectiveData[data.dataIndex].date;
      }

      console.log("Extracted date:", clickedDate);
      console.log("Available chartData.data length:", chartData.data.length);
      console.log("Available collectiveData length:", collectiveData.length);

      if (!clickedDate) {
        console.error(
          "No date found in clicked data. Available keys:",
          Object.keys(data),
        );
        console.error("dataIndex:", data.dataIndex);
        console.error(
          "chartData.data[dataIndex]:",
          chartData.data[data.dataIndex],
        );
        return;
      }

      // Convert date from DD-MM-YYYY format back to YYYY-MM-DD format for API
      const convertDateToAPIFormat = (dateStr: string): string => {
        // If date is in DD-MM-YYYY format, convert to YYYY-MM-DD
        if (dateStr.includes("-") && dateStr.split("-")[0].length === 2) {
          const parts = dateStr.split("-");
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        return dateStr; // Already in correct format or other format
      };

      const apiDate = convertDateToAPIFormat(clickedDate);
      console.log("Converted date for API:", apiDate);

      // For IEX DAM, we only send date and no slot
      const slotData = await fetchExchangeSlotData({
        exchange: "IEX",
        product: "DAM",
        slot: "no-slot", // Special value to indicate no slot
        date: apiDate,
      });

      setPopUpTitle(`IEX DAM Top Buyer Sellers - ${clickedDate}`);
      setPopupData(slotData);
      setPopUpVisible(true);
    } catch (error) {
      console.error("Error fetching slot data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const processVolumeData = () => {
    const par: ChartDataParams = {
      data: collectiveData.map((item) => ({
        ...item,
        count: item.mcv_mw > 0 ? 1 : 0,
      })),
      keys: ["date"],
      volumeKey: "count",
      priceKey: "wt_mcp_rs_mwh",
      groupBy: [],
      aggregationKeys: ["mcv_mwh", "purchase_bid_mwh", "sell_bid_mwh"],
    };

    const data = FormatChartData(par);

    // Convert MWh to Million MWh
    const convertedData = {
      ...data,
      data: data.data.map((item) => {
        const convertedItem = { ...item };
        Object.keys(convertedItem).forEach((key) => {
          if (
            key.includes("_mcv_mwh") &&
            typeof convertedItem[key] === "number"
          ) {
            convertedItem[key] = convertedItem[key] / 1000000; // Convert to Million MWh
          }
          if (
            key.includes("_purchase_bid_mwh") &&
            typeof convertedItem[key] === "number"
          ) {
            convertedItem[key] = convertedItem[key] / 1000000; // Convert to Million MWh
          }
          if (
            key.includes("_sell_bid_mwh") &&
            typeof convertedItem[key] === "number"
          ) {
            convertedItem[key] = convertedItem[key] / 1000000; // Convert to Million MWh
          }
        });
        return convertedItem;
      }),
    };

    setChartData(convertedData);
  };

  const getVolumeLegends = () => {
    return [
      {
        name: "MCV",
        dataKey: "_mcv_mwh",
        stroke: "#f7b288",
        unit: "Million MWh",
        type: ChartType.Bar,
      },
      {
        name: "Purchase Bid",
        dataKey: "_purchase_bid_mwh",
        stroke: "#2A5157",
        legendColor: "#2A5157",
        unit: "Million MWh",
        type: ChartType.Line,
      },
      {
        name: "Sell Bid",
        dataKey: "_sell_bid_mwh",
        stroke: "#EC1C24",
        unit: "Million MWh",
        type: ChartType.Line,
      },
    ];
  };

  const renderVolumeView = () => {
    return (
      <div className="h-full w-full flex flex-col">
        {selectedView === "Chart" && (
          <div className="w-full h-full flex flex-col pb-8">
            <ReMixChart
              data={chartData.data}
              xDataKey="date"
              isTimeSlot={false}
              yAxisLabel="Million MWh"
              isSmallLegend={true}
              unit="Million MWh"
              onlyTitle={true}
              // chartContainerHeight='88%'
              brushStart={BrushStart.End}
              showBrush={true}
              brushIndex={{
                startIndex: Math.max(0, chartData.data.length - 30),
                endIndex: chartData.data.length,
              }}
              syncid={"market-bidding-volume"}
              legends={getVolumeLegends()}
              left={40}
              onBarClick={handleBarClick}
            />
          </div>
        )}
        {selectedView === "Table" && (
          <ChartTable
            data={chartData.data}
            isSmall={true}
            legends={getVolumeLegends()}
            unit="Million MWh"
            extraKeys={["date"]}
            extraLabels={["Date"]}
          />
        )}

        {/* Loading Overlay */}
        {isLoading && (
          <div className="absolute inset-0 bg-black bg-opacity-10 flex items-center justify-center z-10">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
              <p className="text-gray-700 text-sm font-medium"></p>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderParticipantView = () => {
    return (
      <div className="flex-1 min-h-0">
        <TopBuyerSellerTable startDate={startDate} endDate={endDate} />
      </div>
    );
  };

  // Handle tab change
  const handleTabChange = (tab: string) => {
    if (tab === "Participant") {
      // When switching to Participant, store current view and set to Table
      setLastVolumeView(selectedView);
      setSelectedView("Table");
    } else if (tab === "Volume") {
      // When switching back to Volume, restore the last selected view
      setSelectedView(lastVolumeView);
    }
    setSelectedTab(tab);
  };

  // Handle view change (only for Volume tab)
  const handleViewChange = (view: string) => {
    if (selectedTab === "Volume") {
      setSelectedView(view);
      setLastVolumeView(view);
    }
  };

  return (
    <div className="text-left h-full w-full flex flex-col">
      {/* Full-screen Popup for bar click data */}
      {popUpVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setPopUpVisible(false)}
        >
          <div
            style={{
              width: "95vw",
              height: "90vh",
              backgroundColor: "white",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 20px",
                borderBottom: "1px solid #e4e7ed",
                flexShrink: 0,
                backgroundColor: "#f8f9fa",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "500",
                  color: "#333",
                }}
              >
                {popUpTitle}
              </h2>
              <button
                onClick={() => setPopUpVisible(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  padding: "5px",
                  color: "#666",
                }}
              >
                ×
              </button>
            </div>

            {/* Content */}
            <div
              style={{
                flex: 1,
                display: "flex",
                gap: "30px",
                padding: "30px",
                overflow: "hidden",
                backgroundColor: "#ffffff",
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  // backgroundColor: '#f8f9fa',
                  borderRadius: "8px",
                  padding: "20px",
                }}
              >
                <h3
                  style={{
                    textAlign: "center",
                    margin: "0 0 25px 0",
                    color: "#34656d",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Buyers
                </h3>
                <div
                  style={{
                    flex: 1,
                    overflow: "auto",
                    minHeight: "400px",
                  }}
                >
                  <div
                    style={{
                      height: `${Math.max(400, popupData.buyer.length * 50)}px`,
                    }}
                  >
                    <BuyerSellerChart
                      data={popupData.buyer}
                      showLegend={true}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  // backgroundColor: '#f8f9fa',
                  borderRadius: "8px",
                  padding: "20px",
                }}
              >
                <h3
                  style={{
                    textAlign: "center",
                    margin: "0 0 25px 0",
                    color: "#34656d",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Sellers
                </h3>
                <div
                  style={{
                    flex: 1,
                    overflow: "auto",
                    minHeight: "400px",
                  }}
                >
                  <div
                    style={{
                      height: `${Math.max(400, popupData.seller.length * 50)}px`,
                    }}
                  >
                    <BuyerSellerChart
                      data={popupData.seller}
                      showLegend={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className={`flex flex-row gap-x-2 ${isFullscreen ? "justify-end" : "justify-between"}`}
      >
        {!isFullscreen && (
          <h3 className="text-xl font-semibold text-gray-800 flex-shrink-0 chartHeading lg:w-[200px]">
            DAM Bids and MCV
          </h3>
        )}
        <div className="flex flex-row gap-x-2 pb-2">
          <FilterTab
            isSmall={!isFullscreen}
            options={tabs}
            selected={[selectedTab]}
            onClick={handleTabChange}
          />
          <div
            className={
              selectedTab === "Participant"
                ? "opacity-50 pointer-events-none"
                : ""
            }
          >
            <FilterTab
              isSmall={!isFullscreen}
              options={views}
              selected={[selectedView]}
              onClick={handleViewChange}
              disabledOptions={selectedTab === "Participant" ? views : []}
            />
          </div>
          {!isFullscreen && (
            <button
              onClick={() => {
                const event = new CustomEvent("openFullscreen", {
                  detail: "card2",
                });
                window.dispatchEvent(event);
              }}
              className="text-gray-500 hover:text-gray-700 p-1 rounded hover:bg-gray-100 ml-2"
              title="Open in fullscreen"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                />
              </svg>
            </button>
          )}
        </div>
      </div>

      {selectedTab === "Volume" && renderVolumeView()}
      {selectedTab === "Participant" && renderParticipantView()}
    </div>
  );
}
